(function () {
  'use strict';

  angular
    .module('admin.audiences.service', [])
    .factory('AudiencesService', AudiencesService);

  /** @ngInject */
  function AudiencesService($http, $q, API) {

    function list(channelId, totalAmountSpent, numCompletedSetsInChannel) {
      var defered = $q.defer();

      if (!channelId) channelId = ''
      if (!totalAmountSpent) totalAmountSpent = ''
      if (!numCompletedSetsInChannel) numCompletedSetsInChannel = ''

      $http.get(API.API_URL + 'admin/audiences?channelId=' + channelId + '&totalAmountSpent=' + totalAmountSpent + '&numCompletedSetsInChannel=' + numCompletedSetsInChannel)
        .success(defered.resolve);

      return defered.promise;
    }

    return {
      list: list,
    };

  }

})();
